import { default as Block, classForType } from '@intercom/embercom-composer/blocks/types/base/block';
import BlockList from '../block-list';
import BlockRange from '../block-range';
import BlockSelection from '../block-selection';
import BlockMutationResult from '../block-mutation-result';
import ListItem from './list-item';
import AttributeReplacement from '@intercom/embercom-composer/blocks/replacements/attribute';
import { reads } from '@ember/object/computed';
import Em from 'ember';
export default Block.extend({
  isListType: true,
  _ensureDefaultBlock() {
    let blockList = this.get('blockList');
    if (!blockList) {
      this.set('blockList', this._createBlockList());
    }
    blockList._ensureDefaultBlock();
  },
  _createBlockList() {
    return BlockList.create({
      config: this.get('config'),
      allowedChildBlocks: ['listItem'],
      defaultBlockType: ListItem
    });
  },
  isEmpty: Em.computed('blockList.@each.text', function () {
    return this.get('blockList').every(function (item) {
      //TODO: GJ: create an `isEmpty` property for block and make this a one liner
      return item.get('text.length') === 0;
    });
  }),
  innerHtml: reads('blockList.html'),
  endItemIndex: reads('blockList.endBlockIndex'),
  endPositionIndex: reads('blockList.lastObject.endPositionIndex'),
  init() {
    this._super();
    this.deserialize();
    let blockList = this.get('blockList');
    blockList._ensureDefaultBlock();
  },
  deserialize() {
    let config = this.get('config');
    let blockList = this._createBlockList();
    if (this.get('items')) {
      this.get('items').forEach(function (text) {
        if (typeof text === 'string') {
          let block = ListItem.create({
            text,
            config
          });
          AttributeReplacement.tryReplacement(block);
          blockList.pushObject(block);
        }
      });
    }
    this.set('blockList', blockList);
  },
  insert(block, selection) {
    this._ensureDefaultBlock();
    if (selection.get('hasWidth')) {
      throw new Error('You cannot insert a list block using selection with a width');
    }
    if (!block.get('isListType')) {
      throw new Error('You cannot insert a non-list into a list');
    }
    let startBlockIndex = selection.get('startBlockIndex');
    let blockRange = BlockRange.atPositionIndex(selection.get('startPositionIndex'));
    let selectedItem = this.get('blockList').objectAt(startBlockIndex);
    let newListItem = selectedItem.split(blockRange);
    if (!newListItem.get('isEmpty')) {
      this.get('blockList').insertAt(startBlockIndex + 1, newListItem);
    }
    if (selectedItem.get('isEmpty')) {
      this.get('blockList').removeObject(selectedItem);
      startBlockIndex--;
    }
    for (let i = 0; i < block.get('blockList.length'); i++) {
      this.get('blockList').insertAt(startBlockIndex + i + 1, block.get('blockList').objectAt(i));
    }
    let newBlockRange = BlockRange.atItemAndPositionIndex(startBlockIndex + block.get('blockList.length'), block.get('blockList.lastObject.text.length'));
    return BlockMutationResult.create({
      blockRange: newBlockRange
    });
  },
  split(selection, keepEmptyItem) {
    this._ensureDefaultBlock();
    if (selection.get('hasWidth')) {
      throw new Error('You cannot split a list block using selection with a width');
    }
    let startBlockIndex = selection.get('startBlockIndex');
    let blockRange = BlockRange.atPositionIndex(selection.get('startPositionIndex'));
    let selectedItem = this.get('blockList').objectAt(startBlockIndex);
    let selectedItemWasEmpty = selectedItem.get('isEmpty');
    if (!keepEmptyItem || !selectedItemWasEmpty) {
      let newListItem = selectedItem.split(blockRange);
      if (newListItem.get('isNotEmpty')) {
        startBlockIndex++;
        this.get('blockList').insertAt(startBlockIndex, newListItem);
      }
      if (newListItem.get('isEmpty') && selectedItem.get('isNotEmpty')) {
        startBlockIndex++;
      }
      if (selectedItem.get('isEmpty')) {
        this.get('blockList').removeObject(selectedItem);
        if (!selectedItemWasEmpty) {
          startBlockIndex--;
        }
      }
    }
    let itemsForRightBlock = this.get('blockList').slice(startBlockIndex);
    this.get('blockList').removeObjects(itemsForRightBlock);
    let newBlock = classForType(this.get('type')).create({
      config: this.get('config')
    });
    let newBlocklist = this._createBlockList();
    newBlocklist.set('content', itemsForRightBlock);
    newBlock.set('blockList', newBlocklist);
    return newBlock;
  },
  serialized: Em.computed('blockList.@each.serialized', function () {
    //TODO: GJ: extract to general solution
    this._ensureDefaultBlock();
    return {
      type: this.get('type'),
      items: this.get('blockList').map(function (item) {
        return item.get('serialized');
      })
    };
  }),
  applyAction(action, blockRange, options) {
    this._ensureDefaultBlock();
    if (action === 'delete') {
      return this._delete(blockRange);
    }
    if (action === 'insertCharacter') {
      return this._insertCharacter(blockRange, options);
    }
    if (action === 'backspaceWord') {
      return this._backspaceWord(blockRange, options);
    }
    if (action === 'deleteWord') {
      return this._deleteWord(blockRange, options);
    }
  },
  toggleEntity(type, blockRange, options) {
    return this._doEntityAction('toggleEntity', type, blockRange, options);
  },
  addEntity(type, blockRange, options) {
    this._doEntityAction('addEntity', type, blockRange, options);
  },
  removeEntity(type, blockRange, options) {
    this._doEntityAction('removeEntity', type, blockRange, options);
  },
  _doEntityAction(action, type, blockRange, options) {
    options = options || {};
    let selection = this._blockRangeToSelection(blockRange);
    let selectedBlocks = selection.get('selectedBlocks');
    let selectedBlockLength = selectedBlocks.get('length');
    let block;
    let result;
    for (let i = 0; i < selectedBlockLength; i++) {
      block = selectedBlocks.objectAt(i);
      blockRange = this.get('blockList')._blockRangeForSelection(block, selection);
      result = block[action](type, blockRange, options);
    }
    return result;
  },
  findBlockById(id) {
    this._ensureDefaultBlock();
    return this.get('blockList').findBlockById(id);
  },
  hasEntityTypeInRange(entityType, blockRange) {
    this._ensureDefaultBlock();
    let selection = this._blockRangeToSelection(blockRange);
    let result = true;
    selection.get('selectedBlocks').forEach(function (item) {
      result = result && this.get('blockList')._isEntityTypeInBlockSelection(entityType, item, selection);
    }, this);
    return result;
  },
  hasEntityOfTypeCoveringRange(entityType, blockRange) {
    this._ensureDefaultBlock();
    let selection = this._blockRangeToSelection(blockRange);
    return selection._isEntityActive(entityType);
  },
  _delete(blockRange) {
    let selection = this._blockRangeToSelection(blockRange);
    if (selection.get('isSingleBlock')) {
      return selection.get('firstSelectedBlock').delete(BlockRange.atItemAndPositionIndex(selection.get('startItemIndex'), selection.get('startPositionIndex'), selection.get('endItemIndex'), selection.get('endPositionIndex')));
    } else {
      let firstSelectedBlock = selection.get('firstSelectedBlock');
      let lastSelectedBlock = selection.get('lastSelectedBlock');
      this.get('blockList').removeObjects(selection.get('coveredBlocks'));
      firstSelectedBlock.delete(BlockRange.atPositionIndex(selection.get('startPositionIndex'), firstSelectedBlock.get('text.length')));
      if (lastSelectedBlock !== firstSelectedBlock) {
        lastSelectedBlock.delete(BlockRange.atPositionIndex(0, selection.get('endPositionIndex')));
      }
    }
    return BlockMutationResult.create({});
  },
  _insertCharacter(blockRange, options) {
    let selection = this._blockRangeToSelection(blockRange);
    if (selection.get('hasWidth')) {
      throw new Error('Tried to insert a character into a list without collapsing the selection range first, this should never happen');
    }
    let block = selection.get('selectedBlocks.firstObject');
    blockRange = this.get('blockList')._blockRangeForSelection(block, selection);
    return block.applyAction('insertCharacter', blockRange, options);
  },
  _backspaceWord(blockRange) {
    let selection = this._blockRangeToSelection(blockRange);
    if (selection.get('isZeroWidth')) {
      return selection.get('firstSelectedBlock').backspaceWord(BlockRange.atPositionIndex(selection.get('startPositionIndex')));
    } else {
      throw new Error('Non zero width selection passed to ListBlock.backspaceWord');
    }
  },
  _deleteWord(blockRange) {
    let selection = this._blockRangeToSelection(blockRange);
    if (selection.get('isZeroWidth')) {
      return selection.get('firstSelectedBlock').deleteWord(BlockRange.atPositionIndex(selection.get('startPositionIndex')));
    } else {
      throw new Error('Non zero width selection passed to ListBlock.deleteWord');
    }
  },
  _blockRangeToSelection(blockRange) {
    let selection = BlockSelection.fromBlockRange(blockRange);
    selection.set('blockList', this.get('blockList'));
    return selection;
  },
  join(block, options) {
    if (!block) {
      throw new Error('You must provide a block to join with');
    }
    this._ensureDefaultBlock();
    if (block.get('isTextType')) {
      return this._joinWithTextBlock(block);
    }
    if (block.get('type') === 'unorderedList' || block.get('type') === 'orderedList') {
      return this._joinWithList(block, options);
    }
    if (block.get('isCodeBlock')) {
      return this._joinWithCode(block);
    }
    return BlockMutationResult.create({
      blocksToRemove: [block]
    });
  },
  deleteEntityById(id) {
    this.get('blockList').forEach(function (block) {
      let entity = block.findEntityById(id);
      if (entity) {
        block.get('entities').removeObject(entity);
      }
    });
  },
  _joinWithTextBlock(paragraph) {
    let blockList = this.get('blockList');
    let lastListItem = blockList.get('lastObject');
    let lastListItemText = lastListItem.get('text'); // TODO Block.appendText
    lastListItem.set('entities', lastListItem._joinEntitiesFromRight(paragraph));
    lastListItem.set('text', lastListItemText + paragraph.get('text'));
    return BlockMutationResult.create({
      blocksToRemove: [paragraph],
      blockRange: BlockRange.atItemAndPositionIndex(blockList.get('length') - 1, lastListItemText.length)
    });
  },
  _joinWithList(list, options) {
    options = options || {};
    let blockList = this.get('blockList');
    let newItemIndex = blockList.get('length');
    let newPositionIndex = 0;
    if (options.mergeItems) {
      let lastInThis = this.get('blockList.lastObject');
      let firstInJoiner = list.get('blockList.firstObject');
      newPositionIndex = lastInThis.get('text.length');
      newItemIndex--;
      lastInThis.set('text', lastInThis.get('text') + firstInJoiner.get('text'));
      list.get('blockList').removeObject(firstInJoiner);
    }
    blockList.addObjects(list.get('blockList'));
    return BlockMutationResult.create({
      blocksToRemove: [list],
      blockRange: BlockRange.atItemAndPositionIndex(newItemIndex, newPositionIndex)
    });
  },
  _joinWithCode(block) {
    let blockList = this.get('blockList');
    let lastListItem = blockList.get('lastObject');
    let lastListItemText = lastListItem.get('text'); // TODO Block.appendText
    blockList._ensureDefaultBlock();
    lastListItem.set('text', lastListItemText + block.get('text'));
    return BlockMutationResult.create({
      blocksToRemove: [block],
      blockRange: BlockRange.atItemAndPositionIndex(blockList.get('length') - 1, lastListItemText.length)
    });
  }
});